// extracted by mini-css-extract-plugin
module.exports = {"tableSelector":"TableSelector_tableSelector__NEpn6","selected":"TableSelector_selected__29abE","openedBtn":"TableSelector_openedBtn__3toR1"};